import { __read } from "tslib";
import { STORE_APP_ID } from '@office-start/app-gallery-types';
import { HubTileID } from '@office-start/appbar-types';
import { useOfficeComponentContext } from '@office-start/component-context-service';
import * as React from 'react';
/**
 * Custom React Hook responsible for resolving current route data
 */
export function useCurrentInUseTileID() {
    var context = useOfficeComponentContext().data;
    var _a = __read(React.useState(), 2), currentRoute = _a[0], setCurrentRoute = _a[1];
    // Subscribe to the component context's route observable for any route changes
    React.useEffect(function () {
        var componentContext = context;
        var routeObservable = componentContext === null || componentContext === void 0 ? void 0 : componentContext.router.getRouteObservable();
        var subscription = routeObservable === null || routeObservable === void 0 ? void 0 : routeObservable.subscribe(function (newRoute) {
            setCurrentRoute(newRoute);
        });
        return function () {
            if (subscription) {
                subscription.unsubscribe();
            }
        };
    }, [context]);
    var tileID = React.useMemo(function () {
        return translateRouteItemToTileID(currentRoute);
    }, [currentRoute]);
    return tileID;
}
var routeToTileIDMap = {
    officehome: HubTileID.home,
    create: HubTileID.create,
    mycontent: HubTileID.mycontent,
    intents: HubTileID.create,
    orion: HubTileID.orion,
    feed: HubTileID.feed,
    appgallery: HubTileID.appgallery,
};
var fileTypeToTileIDMap = {
    word: HubTileID.word,
    excel: HubTileID.excel,
    powerpoint: HubTileID.powerpoint,
    onenote: HubTileID.onenote,
    sway: HubTileID.sway,
    forms: HubTileID.forms,
    visio: HubTileID.visio,
    stream: HubTileID.stream,
    whiteboard: HubTileID.whiteboard,
    clipchamp: HubTileID.clipchamp,
};
function translateRouteItemToTileID(routeItem) {
    var tileID;
    if (routeItem === null || routeItem === void 0 ? void 0 : routeItem.route) {
        switch (routeItem.route) {
            case 'M365Apps':
                // For MOS apps, the tile ID is in the route's app property
                tileID = routeItem.app;
                if (tileID === STORE_APP_ID) {
                    // If the tile is the Store App, the tile ID should be the ID of the App Gallery tile
                    tileID = HubTileID.appgallery;
                }
                break;
            case 'Start':
            case 'Templates':
                // For start pages, map the FileType to the tile ID
                if (routeItem.app) {
                    tileID = fileTypeToTileIDMap[routeItem.app.toLowerCase()];
                }
                break;
            default:
                // For everything else, map the route to the tile ID
                tileID = routeToTileIDMap[routeItem.route.toLowerCase()];
                break;
        }
    }
    return tileID !== null && tileID !== void 0 ? tileID : HubTileID.home;
}
//# sourceMappingURL=useCurrentInUseTileID.js.map